var WlCom = (function () {
  "use strict";

  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }
  function _extends() {
    return (
      (_extends = Object.assign
        ? Object.assign.bind()
        : function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = arguments[e];
              for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
            }
            return n;
          }),
      _extends.apply(null, arguments)
    );
  }
  function _regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
    var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
      var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
      return (
        _regeneratorDefine(
          u,
          "_invoke",
          (function (r, n, o) {
            var i,
              c,
              u,
              f = 0,
              p = o || [],
              y = !1,
              G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function (t, r) {
                  return (i = t), (c = 0), (u = e), (G.n = r), a;
                },
              };
            function d(r, n) {
              for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                var o,
                  i = p[t],
                  d = G.p,
                  l = i[2];
                r > 3
                  ? (o = l === n) &&
                    ((u = i[(c = i[4]) ? 5 : ((c = 3), 3)]), (i[4] = i[5] = e))
                  : i[0] <= d &&
                    ((o = r < 2 && d < i[1])
                      ? ((c = 0), (G.v = n), (G.n = i[1]))
                      : d < l &&
                        (o = r < 3 || i[0] > n || n > l) &&
                        ((i[4] = r), (i[5] = n), (G.n = l), (c = 0)));
              }
              if (o || r > 1) return a;
              throw ((y = !0), n);
            }
            return function (o, p, l) {
              if (f > 1) throw TypeError("Generator is already running");
              for (
                y && 1 === p && d(p, l), c = p, u = l;
                (t = c < 2 ? e : u) || !y;

              ) {
                i ||
                  (c
                    ? c < 3
                      ? (c > 1 && (G.n = -1), d(c, u))
                      : (G.n = u)
                    : (G.v = u));
                try {
                  if (((f = 2), i)) {
                    if ((c || (o = "next"), (t = i[o]))) {
                      if (!(t = t.call(i, u)))
                        throw TypeError("iterator result is not an object");
                      if (!t.done) return t;
                      (u = t.value), c < 2 && (c = 0);
                    } else
                      1 === c && (t = i.return) && t.call(i),
                        c < 2 &&
                          ((u = TypeError(
                            "The iterator does not provide a '" + o + "' method"
                          )),
                          (c = 1));
                    i = e;
                  } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
                    break;
                } catch (t) {
                  (i = e), (c = 1), (u = t);
                } finally {
                  f = 1;
                }
              }
              return {
                value: t,
                done: y,
              };
            };
          })(r, o, i),
          !0
        ),
        u
      );
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n]
        ? t(t([][n]()))
        : (_regeneratorDefine((t = {}), n, function () {
            return this;
          }),
          t),
      u =
        (GeneratorFunctionPrototype.prototype =
        Generator.prototype =
          Object.create(c));
    function f(e) {
      return (
        Object.setPrototypeOf
          ? Object.setPrototypeOf(e, GeneratorFunctionPrototype)
          : ((e.__proto__ = GeneratorFunctionPrototype),
            _regeneratorDefine(e, o, "GeneratorFunction")),
        (e.prototype = Object.create(u)),
        e
      );
    }
    return (
      (GeneratorFunction.prototype = GeneratorFunctionPrototype),
      _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype),
      _regeneratorDefine(
        GeneratorFunctionPrototype,
        "constructor",
        GeneratorFunction
      ),
      (GeneratorFunction.displayName = "GeneratorFunction"),
      _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"),
      _regeneratorDefine(u),
      _regeneratorDefine(u, o, "Generator"),
      _regeneratorDefine(u, n, function () {
        return this;
      }),
      _regeneratorDefine(u, "toString", function () {
        return "[object Generator]";
      }),
      (_regenerator = function () {
        return {
          w: i,
          m: f,
        };
      })()
    );
  }
  function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
      i({}, "", {});
    } catch (e) {
      i = 0;
    }
    (_regeneratorDefine = function (e, r, n, t) {
      function o(r, n) {
        _regeneratorDefine(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      }
      r
        ? i
          ? i(e, r, {
              value: n,
              enumerable: !t,
              configurable: !t,
              writable: !t,
            })
          : (e[r] = n)
        : (o("next", 0), o("throw", 1), o("return", 2));
    }),
      _regeneratorDefine(e, r, n, t);
  }

  function post(url, data, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
      _ref2$withCredentials = _ref2.withCredentials,
      withCredentials =
        _ref2$withCredentials === void 0 ? true : _ref2$withCredentials,
      _ref2$isJson = _ref2.isJson,
      isJson = _ref2$isJson === void 0 ? true : _ref2$isJson,
      _ref2$timeout = _ref2.timeout,
      timeout = _ref2$timeout === void 0 ? 0 : _ref2$timeout,
      _ref2$headers = _ref2.headers,
      headers = _ref2$headers === void 0 ? {} : _ref2$headers;
    var str = "";
    if (data) {
      for (var key in data) {
        str +=
          encodeURIComponent(key) + "=" + encodeURIComponent(data[key]) + "&";
      }
      str = str.slice(0, -1);
    }
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("post", url);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      for (var header in headers) {
        xhr.setRequestHeader(header, headers[header]);
      }
      xhr.withCredentials = withCredentials;
      xhr.timeout = timeout;
      xhr.send(str);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var resp = isJson ? JSON.parse(xhr.responseText) : xhr.responseText;
            resolve(resp);
          } else {
            reject();
          }
        }
      };
    });
  }

  var version = "5.0.1";
  function wait(durationMs, resolveWith) {
    return new Promise((resolve) =>
      setTimeout(resolve, durationMs, resolveWith)
    );
  }
  function releaseEventLoop() {
    return new Promise((resolve) => {
      const channel = new MessageChannel();
      channel.port1.onmessage = () => resolve();
      channel.port2.postMessage(null);
    });
  }
  function requestIdleCallbackIfAvailable(
    fallbackTimeout,
    deadlineTimeout = Infinity
  ) {
    const { requestIdleCallback } = window;
    if (requestIdleCallback) {
      return new Promise((resolve) =>
        requestIdleCallback.call(window, () => resolve(), {
          timeout: deadlineTimeout,
        })
      );
    } else {
      return wait(Math.min(fallbackTimeout, deadlineTimeout));
    }
  }
  function isPromise(value) {
    return !!value && typeof value.then === "function";
  }
  function awaitIfAsync(action, callback) {
    try {
      const returnedValue = action();
      if (isPromise(returnedValue)) {
        returnedValue.then(
          (result) => callback(true, result),
          (error) => callback(false, error)
        );
      } else {
        callback(true, returnedValue);
      }
    } catch (error) {
      callback(false, error);
    }
  }
  async function mapWithBreaks(items, callback, loopReleaseInterval = 16) {
    const results = Array(items.length);
    let lastLoopReleaseTime = Date.now();
    for (let i = 0; i < items.length; ++i) {
      results[i] = callback(items[i], i);
      const now = Date.now();
      if (now >= lastLoopReleaseTime + loopReleaseInterval) {
        lastLoopReleaseTime = now;
        await releaseEventLoop();
      }
    }
    return results;
  }
  function suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, () => undefined);
    return promise;
  }
  function includes(haystack, needle) {
    for (let i = 0, l = haystack.length; i < l; ++i) {
      if (haystack[i] === needle) {
        return true;
      }
    }
    return false;
  }
  function excludes(haystack, needle) {
    return !includes(haystack, needle);
  }
  function toInt(value) {
    return parseInt(value);
  }
  function toFloat(value) {
    return parseFloat(value);
  }
  function replaceNaN(value, replacement) {
    return typeof value === "number" && isNaN(value) ? replacement : value;
  }
  function countTruthy(values) {
    return values.reduce((sum, value) => sum + (value ? 1 : 0), 0);
  }
  function round(value, base = 1) {
    if (Math.abs(base) >= 1) {
      return Math.round(value / base) * base;
    } else {
      const counterBase = 1 / base;
      return Math.round(value * counterBase) / counterBase;
    }
  }
  function parseSimpleCssSelector(selector) {
    var _a, _b;
    const errorMessage = `Unexpected syntax '${selector}'`;
    const tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    const tag = tagMatch[1] || undefined;
    const attributes = {};
    const partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    const addAttribute = (name, value) => {
      attributes[name] = attributes[name] || [];
      attributes[name].push(value);
    };
    for (;;) {
      const match = partsRegex.exec(tagMatch[2]);
      if (!match) {
        break;
      }
      const part = match[0];
      switch (part[0]) {
        case ".":
          addAttribute("class", part.slice(1));
          break;
        case "#":
          addAttribute("id", part.slice(1));
          break;
        case "[": {
          const attributeMatch =
            /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
          if (attributeMatch) {
            addAttribute(
              attributeMatch[1],
              (_b =
                (_a = attributeMatch[4]) !== null && _a !== void 0
                  ? _a
                  : attributeMatch[5]) !== null && _b !== void 0
                ? _b
                : ""
            );
          } else {
            throw new Error(errorMessage);
          }
          break;
        }
        default:
          throw new Error(errorMessage);
      }
    }
    return [tag, attributes];
  }
  function getUTF8Bytes(input) {
    const result = new Uint8Array(input.length);
    for (let i = 0; i < input.length; i++) {
      const charCode = input.charCodeAt(i);
      if (charCode > 127) {
        return new TextEncoder().encode(input);
      }
      result[i] = charCode;
    }
    return result;
  }
  function x64Add(m, n) {
    const m0 = m[0] >>> 16,
      m1 = m[0] & 0xffff,
      m2 = m[1] >>> 16,
      m3 = m[1] & 0xffff;
    const n0 = n[0] >>> 16,
      n1 = n[0] & 0xffff,
      n2 = n[1] >>> 16,
      n3 = n[1] & 0xffff;
    let o0 = 0,
      o1 = 0,
      o2 = 0,
      o3 = 0;
    o3 += m3 + n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 + n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 + n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 + n0;
    o0 &= 0xffff;
    m[0] = (o0 << 16) | o1;
    m[1] = (o2 << 16) | o3;
  }
  function x64Multiply(m, n) {
    const m0 = m[0] >>> 16,
      m1 = m[0] & 0xffff,
      m2 = m[1] >>> 16,
      m3 = m[1] & 0xffff;
    const n0 = n[0] >>> 16,
      n1 = n[0] & 0xffff,
      n2 = n[1] >>> 16,
      n3 = n[1] & 0xffff;
    let o0 = 0,
      o1 = 0,
      o2 = 0,
      o3 = 0;
    o3 += m3 * n3;
    o2 += o3 >>> 16;
    o3 &= 0xffff;
    o2 += m2 * n3;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o2 += m3 * n2;
    o1 += o2 >>> 16;
    o2 &= 0xffff;
    o1 += m1 * n3;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m2 * n2;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o1 += m3 * n1;
    o0 += o1 >>> 16;
    o1 &= 0xffff;
    o0 += m0 * n3 + m1 * n2 + m2 * n1 + m3 * n0;
    o0 &= 0xffff;
    m[0] = (o0 << 16) | o1;
    m[1] = (o2 << 16) | o3;
  }
  function x64Rotl(m, bits) {
    const m0 = m[0];
    bits %= 64;
    if (bits === 32) {
      m[0] = m[1];
      m[1] = m0;
    } else if (bits < 32) {
      m[0] = (m0 << bits) | (m[1] >>> (32 - bits));
      m[1] = (m[1] << bits) | (m0 >>> (32 - bits));
    } else {
      bits -= 32;
      m[0] = (m[1] << bits) | (m0 >>> (32 - bits));
      m[1] = (m0 << bits) | (m[1] >>> (32 - bits));
    }
  }
  function x64LeftShift(m, bits) {
    bits %= 64;
    if (bits === 0) {
      return;
    } else if (bits < 32) {
      m[0] = m[1] >>> (32 - bits);
      m[1] = m[1] << bits;
    } else {
      m[0] = m[1] << (bits - 32);
      m[1] = 0;
    }
  }
  function x64Xor(m, n) {
    m[0] ^= n[0];
    m[1] ^= n[1];
  }
  const F1 = [0xff51afd7, 0xed558ccd];
  const F2 = [0xc4ceb9fe, 0x1a85ec53];
  function x64Fmix(h) {
    const shifted = [0, h[0] >>> 1];
    x64Xor(h, shifted);
    x64Multiply(h, F1);
    shifted[1] = h[0] >>> 1;
    x64Xor(h, shifted);
    x64Multiply(h, F2);
    shifted[1] = h[0] >>> 1;
    x64Xor(h, shifted);
  }
  const C1 = [0x87c37b91, 0x114253d5];
  const C2 = [0x4cf5ad43, 0x2745937f];
  const M$1 = [0, 5];
  const N1 = [0, 0x52dce729];
  const N2 = [0, 0x38495ab5];
  function x64hash128(input, seed) {
    const key = getUTF8Bytes(input);
    seed = seed || 0;
    const length = [0, key.length];
    const remainder = length[1] % 16;
    const bytes = length[1] - remainder;
    const h1 = [0, seed];
    const h2 = [0, seed];
    const k1 = [0, 0];
    const k2 = [0, 0];
    let i;
    for (i = 0; i < bytes; i = i + 16) {
      k1[0] =
        key[i + 4] |
        (key[i + 5] << 8) |
        (key[i + 6] << 16) |
        (key[i + 7] << 24);
      k1[1] =
        key[i] | (key[i + 1] << 8) | (key[i + 2] << 16) | (key[i + 3] << 24);
      k2[0] =
        key[i + 12] |
        (key[i + 13] << 8) |
        (key[i + 14] << 16) |
        (key[i + 15] << 24);
      k2[1] =
        key[i + 8] |
        (key[i + 9] << 8) |
        (key[i + 10] << 16) |
        (key[i + 11] << 24);
      x64Multiply(k1, C1);
      x64Rotl(k1, 31);
      x64Multiply(k1, C2);
      x64Xor(h1, k1);
      x64Rotl(h1, 27);
      x64Add(h1, h2);
      x64Multiply(h1, M$1);
      x64Add(h1, N1);
      x64Multiply(k2, C2);
      x64Rotl(k2, 33);
      x64Multiply(k2, C1);
      x64Xor(h2, k2);
      x64Rotl(h2, 31);
      x64Add(h2, h1);
      x64Multiply(h2, M$1);
      x64Add(h2, N2);
    }
    k1[0] = 0;
    k1[1] = 0;
    k2[0] = 0;
    k2[1] = 0;
    const val = [0, 0];
    switch (remainder) {
      case 15:
        val[1] = key[i + 14];
        x64LeftShift(val, 48);
        x64Xor(k2, val);
      case 14:
        val[1] = key[i + 13];
        x64LeftShift(val, 40);
        x64Xor(k2, val);
      case 13:
        val[1] = key[i + 12];
        x64LeftShift(val, 32);
        x64Xor(k2, val);
      case 12:
        val[1] = key[i + 11];
        x64LeftShift(val, 24);
        x64Xor(k2, val);
      case 11:
        val[1] = key[i + 10];
        x64LeftShift(val, 16);
        x64Xor(k2, val);
      case 10:
        val[1] = key[i + 9];
        x64LeftShift(val, 8);
        x64Xor(k2, val);
      case 9:
        val[1] = key[i + 8];
        x64Xor(k2, val);
        x64Multiply(k2, C2);
        x64Rotl(k2, 33);
        x64Multiply(k2, C1);
        x64Xor(h2, k2);
      case 8:
        val[1] = key[i + 7];
        x64LeftShift(val, 56);
        x64Xor(k1, val);
      case 7:
        val[1] = key[i + 6];
        x64LeftShift(val, 48);
        x64Xor(k1, val);
      case 6:
        val[1] = key[i + 5];
        x64LeftShift(val, 40);
        x64Xor(k1, val);
      case 5:
        val[1] = key[i + 4];
        x64LeftShift(val, 32);
        x64Xor(k1, val);
      case 4:
        val[1] = key[i + 3];
        x64LeftShift(val, 24);
        x64Xor(k1, val);
      case 3:
        val[1] = key[i + 2];
        x64LeftShift(val, 16);
        x64Xor(k1, val);
      case 2:
        val[1] = key[i + 1];
        x64LeftShift(val, 8);
        x64Xor(k1, val);
      case 1:
        val[1] = key[i];
        x64Xor(k1, val);
        x64Multiply(k1, C1);
        x64Rotl(k1, 31);
        x64Multiply(k1, C2);
        x64Xor(h1, k1);
    }
    x64Xor(h1, length);
    x64Xor(h2, length);
    x64Add(h1, h2);
    x64Add(h2, h1);
    x64Fmix(h1);
    x64Fmix(h2);
    x64Add(h1, h2);
    x64Add(h2, h1);
    return (
      ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) +
      ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) +
      ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) +
      ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8)
    );
  }
  function errorToObject(error) {
    var _a;
    return {
      name: error.name,
      message: error.message,
      stack:
        (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split("\n"),
      ...error,
    };
  }
  function isFunctionNative(func) {
    return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(func));
  }
  function isFinalResultLoaded(loadResult) {
    return typeof loadResult !== "function";
  }
  function loadSource(source, sourceOptions) {
    const sourceLoadPromise = suppressUnhandledRejectionWarning(
      new Promise((resolveLoad) => {
        const loadStartTime = Date.now();
        awaitIfAsync(source.bind(null, sourceOptions), (...loadArgs) => {
          const loadDuration = Date.now() - loadStartTime;
          if (!loadArgs[0]) {
            return resolveLoad(() => ({
              error: loadArgs[1],
              duration: loadDuration,
            }));
          }
          const loadResult = loadArgs[1];
          if (isFinalResultLoaded(loadResult)) {
            return resolveLoad(() => ({
              value: loadResult,
              duration: loadDuration,
            }));
          }
          resolveLoad(
            () =>
              new Promise((resolveGet) => {
                const getStartTime = Date.now();
                awaitIfAsync(loadResult, (...getArgs) => {
                  const duration = loadDuration + Date.now() - getStartTime;
                  if (!getArgs[0]) {
                    return resolveGet({
                      error: getArgs[1],
                      duration,
                    });
                  }
                  resolveGet({
                    value: getArgs[1],
                    duration,
                  });
                });
              })
          );
        });
      })
    );
    return function getComponent() {
      return sourceLoadPromise.then((finalizeSource) => finalizeSource());
    };
  }
  function loadSources(
    sources,
    sourceOptions,
    excludeSources,
    loopReleaseInterval
  ) {
    const includedSources = Object.keys(sources).filter((sourceKey) =>
      excludes(excludeSources, sourceKey)
    );
    const sourceGettersPromise = suppressUnhandledRejectionWarning(
      mapWithBreaks(
        includedSources,
        (sourceKey) => loadSource(sources[sourceKey], sourceOptions),
        loopReleaseInterval
      )
    );
    return async function getComponents() {
      const sourceGetters = await sourceGettersPromise;
      const componentPromises = await mapWithBreaks(
        sourceGetters,
        (sourceGetter) => suppressUnhandledRejectionWarning(sourceGetter()),
        loopReleaseInterval
      );
      const componentArray = await Promise.all(componentPromises);
      const components = {};
      for (let index = 0; index < includedSources.length; ++index) {
        components[includedSources[index]] = componentArray[index];
      }
      return components;
    };
  }
  function isTrident() {
    const w = window;
    const n = navigator;
    return (
      countTruthy([
        "MSCSSMatrix" in w,
        "msSetImmediate" in w,
        "msIndexedDB" in w,
        "msMaxTouchPoints" in n,
        "msPointerEnabled" in n,
      ]) >= 4
    );
  }
  function isEdgeHTML() {
    const w = window;
    const n = navigator;
    return (
      countTruthy([
        "msWriteProfilerMark" in w,
        "MSStream" in w,
        "msLaunchUri" in n,
        "msSaveBlob" in n,
      ]) >= 3 && !isTrident()
    );
  }
  function isChromium() {
    const w = window;
    const n = navigator;
    return (
      countTruthy([
        "webkitPersistentStorage" in n,
        "webkitTemporaryStorage" in n,
        (n.vendor || "").indexOf("Google") === 0,
        "webkitResolveLocalFileSystemURL" in w,
        "BatteryManager" in w,
        "webkitMediaStream" in w,
        "webkitSpeechGrammar" in w,
      ]) >= 5
    );
  }
  function isWebKit() {
    const w = window;
    const n = navigator;
    return (
      countTruthy([
        "ApplePayError" in w,
        "CSSPrimitiveValue" in w,
        "Counter" in w,
        n.vendor.indexOf("Apple") === 0,
        "RGBColor" in w,
        "WebKitMediaKeys" in w,
      ]) >= 4
    );
  }
  function isDesktopWebKit() {
    const w = window;
    const { HTMLElement, Document } = w;
    return (
      countTruthy([
        "safari" in w,
        !("ongestureend" in w),
        !("TouchEvent" in w),
        !("orientation" in w),
        HTMLElement && !("autocapitalize" in HTMLElement.prototype),
        Document && "pointerLockElement" in Document.prototype,
      ]) >= 4
    );
  }
  function isSafariWebKit() {
    const w = window;
    return (
      isFunctionNative(w.print) &&
      String(w.browser) === "[object WebPageNamespace]"
    );
  }
  function isGecko() {
    var _a, _b;
    const w = window;
    return (
      countTruthy([
        "buildID" in navigator,
        "MozAppearance" in
          ((_b =
            (_a = document.documentElement) === null || _a === void 0
              ? void 0
              : _a.style) !== null && _b !== void 0
            ? _b
            : {}),
        "onmozfullscreenchange" in w,
        "mozInnerScreenX" in w,
        "CSSMozDocumentRule" in w,
        "CanvasCaptureMediaStream" in w,
      ]) >= 4
    );
  }
  function isChromium86OrNewer() {
    const w = window;
    return (
      countTruthy([
        !("MediaSettingsRange" in w),
        "RTCEncodedAudioFrame" in w,
        "" + w.Intl === "[object Intl]",
        "" + w.Reflect === "[object Reflect]",
      ]) >= 3
    );
  }
  function isChromium122OrNewer() {
    const w = window;
    const { URLPattern } = w;
    return (
      countTruthy([
        "union" in Set.prototype,
        "Iterator" in w,
        URLPattern && "hasRegExpGroups" in URLPattern.prototype,
        "RGB8" in WebGLRenderingContext.prototype,
      ]) >= 3
    );
  }
  function isWebKit606OrNewer() {
    const w = window;
    return (
      countTruthy([
        "DOMRectList" in w,
        "RTCPeerConnectionIceEvent" in w,
        "SVGGeometryElement" in w,
        "ontransitioncancel" in w,
      ]) >= 3
    );
  }
  function isWebKit616OrNewer() {
    const w = window;
    const n = navigator;
    const { CSS, HTMLButtonElement } = w;
    return (
      countTruthy([
        !("getStorageUpdates" in n),
        HTMLButtonElement && "popover" in HTMLButtonElement.prototype,
        "CSSCounterStyleRule" in w,
        CSS.supports("font-size-adjust: ex-height 0.5"),
        CSS.supports("text-transform: full-width"),
      ]) >= 4
    );
  }
  function isIPad() {
    if (navigator.platform === "iPad") {
      return true;
    }
    const s = screen;
    const screenRatio = s.width / s.height;
    return (
      countTruthy([
        "MediaSource" in window,
        !!Element.prototype.webkitRequestFullscreen,
        screenRatio > 0.65 && screenRatio < 1.53,
      ]) >= 2
    );
  }
  function getFullscreenElement() {
    const d = document;
    return (
      d.fullscreenElement ||
      d.msFullscreenElement ||
      d.mozFullScreenElement ||
      d.webkitFullscreenElement ||
      null
    );
  }
  function exitFullscreen() {
    const d = document;
    return (
      d.exitFullscreen ||
      d.msExitFullscreen ||
      d.mozCancelFullScreen ||
      d.webkitExitFullscreen
    ).call(d);
  }
  function isAndroid() {
    const isItChromium = isChromium();
    const isItGecko = isGecko();
    const w = window;
    const n = navigator;
    const c = "connection";
    if (isItChromium) {
      return (
        countTruthy([
          !("SharedWorker" in w),
          n[c] && "ontypechange" in n[c],
          !("sinkId" in new Audio()),
        ]) >= 2
      );
    } else if (isItGecko) {
      return (
        countTruthy([
          "onorientationchange" in w,
          "orientation" in w,
          /android/i.test(n.appVersion),
        ]) >= 2
      );
    } else {
      return false;
    }
  }
  function isSamsungInternet() {
    const n = navigator;
    const w = window;
    const audioPrototype = Audio.prototype;
    const { visualViewport } = w;
    return (
      countTruthy([
        "srLatency" in audioPrototype,
        "srChannelCount" in audioPrototype,
        "devicePosture" in n,
        visualViewport && "segments" in visualViewport,
        "getTextInformation" in Image.prototype,
      ]) >= 3
    );
  }
  function getAudioFingerprint() {
    if (doesBrowserPerformAntifingerprinting$1()) {
      return -4;
    }
    return getUnstableAudioFingerprint();
  }
  function getUnstableAudioFingerprint() {
    const w = window;
    const AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
    if (!AudioContext) {
      return -2;
    }
    if (doesBrowserSuspendAudioContext()) {
      return -1;
    }
    const hashFromIndex = 4500;
    const hashToIndex = 5000;
    const context = new AudioContext(1, hashToIndex, 44100);
    const oscillator = context.createOscillator();
    oscillator.type = "triangle";
    oscillator.frequency.value = 10000;
    const compressor = context.createDynamicsCompressor();
    compressor.threshold.value = -50;
    compressor.knee.value = 40;
    compressor.ratio.value = 12;
    compressor.attack.value = 0;
    compressor.release.value = 0.25;
    oscillator.connect(compressor);
    compressor.connect(context.destination);
    oscillator.start(0);
    const [renderPromise, finishRendering] = startRenderingAudio(context);
    const fingerprintPromise = suppressUnhandledRejectionWarning(
      renderPromise.then(
        (buffer) => getHash(buffer.getChannelData(0).subarray(hashFromIndex)),
        (error) => {
          if (error.name === "timeout" || error.name === "suspended") {
            return -3;
          }
          throw error;
        }
      )
    );
    return () => {
      finishRendering();
      return fingerprintPromise;
    };
  }
  function doesBrowserSuspendAudioContext() {
    return isWebKit() && !isDesktopWebKit() && !isWebKit606OrNewer();
  }
  function doesBrowserPerformAntifingerprinting$1() {
    return (
      (isWebKit() && isWebKit616OrNewer() && isSafariWebKit()) ||
      (isChromium() && isSamsungInternet() && isChromium122OrNewer())
    );
  }
  function startRenderingAudio(context) {
    const renderTryMaxCount = 3;
    const renderRetryDelay = 500;
    const runningMaxAwaitTime = 500;
    const runningSufficientTime = 5000;
    let finalize = () => undefined;
    const resultPromise = new Promise((resolve, reject) => {
      let isFinalized = false;
      let renderTryCount = 0;
      let startedRunningAt = 0;
      context.oncomplete = (event) => resolve(event.renderedBuffer);
      const startRunningTimeout = () => {
        setTimeout(
          () => reject(makeInnerError("timeout")),
          Math.min(
            runningMaxAwaitTime,
            startedRunningAt + runningSufficientTime - Date.now()
          )
        );
      };
      const tryRender = () => {
        try {
          const renderingPromise = context.startRendering();
          if (isPromise(renderingPromise)) {
            suppressUnhandledRejectionWarning(renderingPromise);
          }
          switch (context.state) {
            case "running":
              startedRunningAt = Date.now();
              if (isFinalized) {
                startRunningTimeout();
              }
              break;
            case "suspended":
              if (!document.hidden) {
                renderTryCount++;
              }
              if (isFinalized && renderTryCount >= renderTryMaxCount) {
                reject(makeInnerError("suspended"));
              } else {
                setTimeout(tryRender, renderRetryDelay);
              }
              break;
          }
        } catch (error) {
          reject(error);
        }
      };
      tryRender();
      finalize = () => {
        if (!isFinalized) {
          isFinalized = true;
          if (startedRunningAt > 0) {
            startRunningTimeout();
          }
        }
      };
    });
    return [resultPromise, finalize];
  }
  function getHash(signal) {
    let hash = 0;
    for (let i = 0; i < signal.length; ++i) {
      hash += Math.abs(signal[i]);
    }
    return hash;
  }
  function makeInnerError(name) {
    const error = new Error(name);
    error.name = name;
    return error;
  }
  async function withIframe(action, initialHtml, domPollInterval = 50) {
    var _a, _b, _c;
    const d = document;
    while (!d.body) {
      await wait(domPollInterval);
    }
    const iframe = d.createElement("iframe");
    try {
      await new Promise((_resolve, _reject) => {
        let isComplete = false;
        const resolve = () => {
          isComplete = true;
          _resolve();
        };
        const reject = (error) => {
          isComplete = true;
          _reject(error);
        };
        iframe.onload = resolve;
        iframe.onerror = reject;
        const { style } = iframe;
        style.setProperty("display", "block", "important");
        style.position = "absolute";
        style.top = "0";
        style.left = "0";
        style.visibility = "hidden";
        if (initialHtml && "srcdoc" in iframe) {
          iframe.srcdoc = initialHtml;
        } else {
          iframe.src = "about:blank";
        }
        d.body.appendChild(iframe);
        const checkReadyState = () => {
          var _a, _b;
          if (isComplete) {
            return;
          }
          if (
            ((_b =
              (_a = iframe.contentWindow) === null || _a === void 0
                ? void 0
                : _a.document) === null || _b === void 0
              ? void 0
              : _b.readyState) === "complete"
          ) {
            resolve();
          } else {
            setTimeout(checkReadyState, 10);
          }
        };
        checkReadyState();
      });
      while (
        !((_b =
          (_a = iframe.contentWindow) === null || _a === void 0
            ? void 0
            : _a.document) === null || _b === void 0
          ? void 0
          : _b.body)
      ) {
        await wait(domPollInterval);
      }
      return await action(iframe, iframe.contentWindow);
    } finally {
      (_c = iframe.parentNode) === null || _c === void 0
        ? void 0
        : _c.removeChild(iframe);
    }
  }
  function selectorToElement(selector) {
    const [tag, attributes] = parseSimpleCssSelector(selector);
    const element = document.createElement(
      tag !== null && tag !== void 0 ? tag : "div"
    );
    for (const name of Object.keys(attributes)) {
      const value = attributes[name].join(" ");
      if (name === "style") {
        addStyleString(element.style, value);
      } else {
        element.setAttribute(name, value);
      }
    }
    return element;
  }
  function addStyleString(style, source) {
    for (const property of source.split(";")) {
      const match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(
        property
      );
      if (match) {
        const [, name, value, , priority] = match;
        style.setProperty(name, value, priority || "");
      }
    }
  }
  function isAnyParentCrossOrigin() {
    let currentWindow = window;
    for (;;) {
      const parentWindow = currentWindow.parent;
      if (!parentWindow || parentWindow === currentWindow) {
        return false;
      }
      try {
        if (parentWindow.location.origin !== currentWindow.location.origin) {
          return true;
        }
      } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
          return true;
        }
        throw error;
      }
      currentWindow = parentWindow;
    }
  }
  const testString = "mmMwWLliI0O&1";
  const textSize = "48px";
  const baseFonts = ["monospace", "sans-serif", "serif"];
  const fontList = [
    "sans-serif-thin",
    "ARNO PRO",
    "Agency FB",
    "Arabic Typesetting",
    "Arial Unicode MS",
    "AvantGarde Bk BT",
    "BankGothic Md BT",
    "Batang",
    "Bitstream Vera Sans Mono",
    "Calibri",
    "Century",
    "Century Gothic",
    "Clarendon",
    "EUROSTILE",
    "Franklin Gothic",
    "Futura Bk BT",
    "Futura Md BT",
    "GOTHAM",
    "Gill Sans",
    "HELV",
    "Haettenschweiler",
    "Helvetica Neue",
    "Humanst521 BT",
    "Leelawadee",
    "Letter Gothic",
    "Levenim MT",
    "Lucida Bright",
    "Lucida Sans",
    "Menlo",
    "MS Mincho",
    "MS Outlook",
    "MS Reference Specialty",
    "MS UI Gothic",
    "MT Extra",
    "MYRIAD PRO",
    "Marlett",
    "Meiryo UI",
    "Microsoft Uighur",
    "Minion Pro",
    "Monotype Corsiva",
    "PMingLiU",
    "Pristina",
    "SCRIPTINA",
    "Segoe UI Light",
    "Serifa",
    "SimHei",
    "Small Fonts",
    "Staccato222 BT",
    "TRAJAN PRO",
    "Univers CE 55 Medium",
    "Vrinda",
    "ZWAdobeF",
  ];
  function getFonts() {
    return withIframe(async (_, { document }) => {
      const holder = document.body;
      holder.style.fontSize = textSize;
      const spansContainer = document.createElement("div");
      spansContainer.style.setProperty("visibility", "hidden", "important");
      const defaultWidth = {};
      const defaultHeight = {};
      const createSpan = (fontFamily) => {
        const span = document.createElement("span");
        const { style } = span;
        style.position = "absolute";
        style.top = "0";
        style.left = "0";
        style.fontFamily = fontFamily;
        span.textContent = testString;
        spansContainer.appendChild(span);
        return span;
      };
      const createSpanWithFonts = (fontToDetect, baseFont) => {
        return createSpan(`'${fontToDetect}',${baseFont}`);
      };
      const initializeBaseFontsSpans = () => {
        return baseFonts.map(createSpan);
      };
      const initializeFontsSpans = () => {
        const spans = {};
        for (const font of fontList) {
          spans[font] = baseFonts.map((baseFont) =>
            createSpanWithFonts(font, baseFont)
          );
        }
        return spans;
      };
      const isFontAvailable = (fontSpans) => {
        return baseFonts.some(
          (baseFont, baseFontIndex) =>
            fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
            fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont]
        );
      };
      const baseFontsSpans = initializeBaseFontsSpans();
      const fontsSpans = initializeFontsSpans();
      holder.appendChild(spansContainer);
      for (let index = 0; index < baseFonts.length; index++) {
        defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth;
        defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight;
      }
      return fontList.filter((font) => isFontAvailable(fontsSpans[font]));
    });
  }
  function getPlugins() {
    const rawPlugins = navigator.plugins;
    if (!rawPlugins) {
      return undefined;
    }
    const plugins = [];
    for (let i = 0; i < rawPlugins.length; ++i) {
      const plugin = rawPlugins[i];
      if (!plugin) {
        continue;
      }
      const mimeTypes = [];
      for (let j = 0; j < plugin.length; ++j) {
        const mimeType = plugin[j];
        mimeTypes.push({
          type: mimeType.type,
          suffixes: mimeType.suffixes,
        });
      }
      plugins.push({
        name: plugin.name,
        description: plugin.description,
        mimeTypes,
      });
    }
    return plugins;
  }
  function getCanvasFingerprint() {
    return getUnstableCanvasFingerprint(doesBrowserPerformAntifingerprinting());
  }
  function getUnstableCanvasFingerprint(skipImages) {
    let winding = false;
    let geometry;
    let text;
    const [canvas, context] = makeCanvasContext();
    if (!isSupported(canvas, context)) {
      geometry = text = "unsupported";
    } else {
      winding = doesSupportWinding(context);
      if (skipImages) {
        geometry = text = "skipped";
      } else {
        [geometry, text] = renderImages(canvas, context);
      }
    }
    return {
      winding,
      geometry,
      text,
    };
  }
  function makeCanvasContext() {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return [canvas, canvas.getContext("2d")];
  }
  function isSupported(canvas, context) {
    return !!(context && canvas.toDataURL);
  }
  function doesSupportWinding(context) {
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, "evenodd");
  }
  function renderImages(canvas, context) {
    renderTextImage(canvas, context);
    const textImage1 = canvasToString(canvas);
    const textImage2 = canvasToString(canvas);
    if (textImage1 !== textImage2) {
      return ["unstable", "unstable"];
    }
    renderGeometryImage(canvas, context);
    const geometryImage = canvasToString(canvas);
    return [geometryImage, textImage1];
  }
  function renderTextImage(canvas, context) {
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#f60";
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = "#069";
    context.font = '11pt "Times New Roman"';
    const printedText = `Cwm fjordbank gly ${String.fromCharCode(
      55357,
      56835
    )}`;
    context.fillText(printedText, 2, 15);
    context.fillStyle = "rgba(102, 204, 0, 0.2)";
    context.font = "18pt Arial";
    context.fillText(printedText, 4, 45);
  }
  function renderGeometryImage(canvas, context) {
    canvas.width = 122;
    canvas.height = 110;
    context.globalCompositeOperation = "multiply";
    for (const [color, x, y] of [
      ["#f2f", 40, 40],
      ["#2ff", 80, 40],
      ["#ff2", 60, 80],
    ]) {
      context.fillStyle = color;
      context.beginPath();
      context.arc(x, y, 40, 0, Math.PI * 2, true);
      context.closePath();
      context.fill();
    }
    context.fillStyle = "#f9c";
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill("evenodd");
  }
  function canvasToString(canvas) {
    return canvas.toDataURL();
  }
  function doesBrowserPerformAntifingerprinting() {
    return isWebKit() && isWebKit616OrNewer() && isSafariWebKit();
  }
  function getTouchSupport() {
    const n = navigator;
    let maxTouchPoints = 0;
    let touchEvent;
    if (n.maxTouchPoints !== undefined) {
      maxTouchPoints = toInt(n.maxTouchPoints);
    } else if (n.msMaxTouchPoints !== undefined) {
      maxTouchPoints = n.msMaxTouchPoints;
    }
    try {
      document.createEvent("TouchEvent");
      touchEvent = true;
    } catch (_a) {
      touchEvent = false;
    }
    const touchStart = "ontouchstart" in window;
    return {
      maxTouchPoints,
      touchEvent,
      touchStart,
    };
  }
  function getOsCpu() {
    return navigator.oscpu;
  }
  function getLanguages() {
    const n = navigator;
    const result = [];
    const language =
      n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
      result.push([language]);
    }
    if (Array.isArray(n.languages)) {
      if (!(isChromium() && isChromium86OrNewer())) {
        result.push(n.languages);
      }
    } else if (typeof n.languages === "string") {
      const languages = n.languages;
      if (languages) {
        result.push(languages.split(","));
      }
    }
    return result;
  }
  function getColorDepth() {
    return window.screen.colorDepth;
  }
  function getDeviceMemory() {
    return replaceNaN(toFloat(navigator.deviceMemory), undefined);
  }
  function getScreenResolution() {
    if (isWebKit() && isWebKit616OrNewer() && isSafariWebKit()) {
      return undefined;
    }
    return getUnstableScreenResolution();
  }
  function getUnstableScreenResolution() {
    const s = screen;
    const parseDimension = (value) => replaceNaN(toInt(value), null);
    const dimensions = [parseDimension(s.width), parseDimension(s.height)];
    dimensions.sort().reverse();
    return dimensions;
  }
  const screenFrameCheckInterval = 2500;
  const roundingPrecision = 10;
  let screenFrameBackup;
  let screenFrameSizeTimeoutId;
  function watchScreenFrame() {
    if (screenFrameSizeTimeoutId !== undefined) {
      return;
    }
    const checkScreenFrame = () => {
      const frameSize = getCurrentScreenFrame();
      if (isFrameSizeNull(frameSize)) {
        screenFrameSizeTimeoutId = setTimeout(
          checkScreenFrame,
          screenFrameCheckInterval
        );
      } else {
        screenFrameBackup = frameSize;
        screenFrameSizeTimeoutId = undefined;
      }
    };
    checkScreenFrame();
  }
  function getUnstableScreenFrame() {
    watchScreenFrame();
    return async () => {
      let frameSize = getCurrentScreenFrame();
      if (isFrameSizeNull(frameSize)) {
        if (screenFrameBackup) {
          return [...screenFrameBackup];
        }
        if (getFullscreenElement()) {
          await exitFullscreen();
          frameSize = getCurrentScreenFrame();
        }
      }
      if (!isFrameSizeNull(frameSize)) {
        screenFrameBackup = frameSize;
      }
      return frameSize;
    };
  }
  function getScreenFrame() {
    if (isWebKit() && isWebKit616OrNewer() && isSafariWebKit()) {
      return () => Promise.resolve(undefined);
    }
    const screenFrameGetter = getUnstableScreenFrame();
    return async () => {
      const frameSize = await screenFrameGetter();
      const processSize = (sideSize) =>
        sideSize === null ? null : round(sideSize, roundingPrecision);
      return [
        processSize(frameSize[0]),
        processSize(frameSize[1]),
        processSize(frameSize[2]),
        processSize(frameSize[3]),
      ];
    };
  }
  function getCurrentScreenFrame() {
    const s = screen;
    return [
      replaceNaN(toFloat(s.availTop), null),
      replaceNaN(
        toFloat(s.width) -
          toFloat(s.availWidth) -
          replaceNaN(toFloat(s.availLeft), 0),
        null
      ),
      replaceNaN(
        toFloat(s.height) -
          toFloat(s.availHeight) -
          replaceNaN(toFloat(s.availTop), 0),
        null
      ),
      replaceNaN(toFloat(s.availLeft), null),
    ];
  }
  function isFrameSizeNull(frameSize) {
    for (let i = 0; i < 4; ++i) {
      if (frameSize[i]) {
        return false;
      }
    }
    return true;
  }
  function getHardwareConcurrency() {
    return replaceNaN(toInt(navigator.hardwareConcurrency), undefined);
  }
  function getTimezone() {
    var _a;
    const DateTimeFormat =
      (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
      const timezone = new DateTimeFormat().resolvedOptions().timeZone;
      if (timezone) {
        return timezone;
      }
    }
    const offset = -getTimezoneOffset();
    return `UTC${offset >= 0 ? "+" : ""}${offset}`;
  }
  function getTimezoneOffset() {
    const currentYear = new Date().getFullYear();
    return Math.max(
      toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()),
      toFloat(new Date(currentYear, 6, 1).getTimezoneOffset())
    );
  }
  function getSessionStorage() {
    try {
      return !!window.sessionStorage;
    } catch (error) {
      return true;
    }
  }
  function getLocalStorage() {
    try {
      return !!window.localStorage;
    } catch (e) {
      return true;
    }
  }
  function getIndexedDB() {
    if (isTrident() || isEdgeHTML()) {
      return undefined;
    }
    try {
      return !!window.indexedDB;
    } catch (e) {
      return true;
    }
  }
  function getOpenDatabase() {
    return !!window.openDatabase;
  }
  function getCpuClass() {
    return navigator.cpuClass;
  }
  function getPlatform() {
    const { platform } = navigator;
    if (platform === "MacIntel") {
      if (isWebKit() && !isDesktopWebKit()) {
        return isIPad() ? "iPad" : "iPhone";
      }
    }
    return platform;
  }
  function getVendor() {
    return navigator.vendor || "";
  }
  function getVendorFlavors() {
    const flavors = [];
    for (const key of [
      "chrome",
      "safari",
      "__crWeb",
      "__gCrWeb",
      "yandex",
      "__yb",
      "__ybro",
      "__firefox__",
      "__edgeTrackingPreventionStatistics",
      "webkit",
      "oprt",
      "samsungAr",
      "ucweb",
      "UCShellJava",
      "puffinDevice",
    ]) {
      const value = window[key];
      if (value && typeof value === "object") {
        flavors.push(key);
      }
    }
    return flavors.sort();
  }
  function areCookiesEnabled() {
    const d = document;
    try {
      d.cookie = "cookietest=1; SameSite=Strict;";
      const result = d.cookie.indexOf("cookietest=") !== -1;
      d.cookie =
        "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT";
      return result;
    } catch (e) {
      return false;
    }
  }
  function getFilters() {
    return {
      abpIndo: [
        "#Iklan-Melayang",
        "#Kolom-Iklan-728",
        "#SidebarIklan-wrapper",
        '[title="ALIENBOLA" i]',
        "#Box-Banner-a" + "ds",
      ],
      abpvn: [
        ".quangcao",
        "#mobileCatfish",
        ".close-ads",
        '[id^="bn_bottom_fixed_"]',
        "#pmadv",
      ],
      adBlockFinland: [
        ".mainostila",
        ".sponsorit",
        ".ylamainos",
        'a[href*="/clickthrgh.asp?"]',
        'a[href^="https://app.read' + 'peak.com/ads"]',
      ],
      adBlockPersian: [
        "#navbar_notice_50",
        ".kadr",
        'TABLE[width="140px"]',
        "#divAgahi",
        'a[href^="http://g1.v.fwm' + 'rm.net/ad/"]',
      ],
      adBlockWarningRemoval: [
        "#adblock-honeypot",
        ".adblocker-root",
        ".wp_adblock_detect",
        ".header-blocked-ad",
        "#ad_blocker",
      ],
      adGuardAnnoyances: [
        ".hs-sosyal",
        "#cookieconsentdiv",
        'div[class^="app_gdpr"]',
        ".as-oil",
        '[data-cypress="soft-push-notification-modal"]',
      ],
      adGuardBase: [
        ".BetterJsPopOverlay",
        "#ad_300X250",
        "#bannerfloat22",
        "#campaign-banner",
        "#Ad-Content",
      ],
      adGuardChinese: [
        ".Zi_ad_a_H",
        'a[href*=".hthb' + 'et34.com"]',
        "#widget-quan",
        'a[href*="/8499' + '2020.xyz"]',
        'a[href*=".195' + '6hl.com/"]',
      ],
      adGuardFrench: [
        "#pavePub",
        ".ad-desktop-rectangle",
        ".mobile_adhesion",
        ".widgetadv",
        ".ads_ban",
      ],
      adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
      adGuardJapanese: [
        "#kauli_yad_1",
        'a[href^="http://ad2.traffi' + 'cgate.net/"]',
        "._popIn_infinite_ad",
        ".adgoogle",
        ".__isboostReturnAd",
      ],
      adGuardMobile: [
        "amp-auto-ads",
        ".amp_ad",
        'amp-embed[type="24smi"]',
        "#mgid_iframe1",
        "#ad_inview_area",
      ],
      adGuardRussian: [
        'a[href^="https://ad.letm' + 'eads.com/"]',
        ".reclama",
        'div[id^="smi2adblock"]',
        'div[id^="AdFox_banner_"]',
        "#psyduckpockeball",
      ],
      adGuardSocial: [
        'a[href^="//www.stumb' + 'leupon.com/submit?url="]',
        'a[href^="//teleg' + 'ram.me/share/url?"]',
        ".etsy-tweet",
        "#inlineShare",
        ".popup-social",
      ],
      adGuardSpanishPortuguese: [
        "#barraPublicidade",
        "#Publicidade",
        "#publiEspecial",
        "#queTooltip",
        ".cnt-publi",
      ],
      adGuardTrackingProtection: [
        "#qoo-counter",
        'a[href^="http://cl' + "ick.hot" + 'log.ru/"]',
        'a[href^="http://hitco' + "unter.ru/top/s" + 'tat.php"]',
        'a[href^="http://top.m' + 'ail.ru/jump"]',
        "#top100counter",
      ],
      adGuardTurkish: [
        "#backkapat",
        "#reklami",
        'a[href^="http://ads' + 'erv.ontek.com.tr/"]',
        'a[href^="http://izl' + 'enzi.com/campaign/"]',
        'a[href^="http://www.ins' + 'tallads.net/"]',
      ],
      bulgarian: [
        "td#freenet_table_ads",
        "#ea_intext_div",
        ".lapni-pop-over",
        "#xenium_hot_offers",
      ],
      easyList: [
        ".yb-floorad",
        ".widget_po_ads_widget",
        ".trafficjunky-ad",
        ".textad_headline",
        ".sponsored-text-links",
      ],
      easyListChina: [
        '.appguide-wrap[onclick*="bcebos.com"]',
        ".frontpageAdvM",
        "#taotaole",
        "#aafoot.top_box",
        ".cfa_popup",
      ],
      easyListCookie: [
        ".ezmob-footer",
        ".cc-CookieWarning",
        "[data-cookie-number]",
        ".aw-cookie-banner",
        ".sygnal24-gdpr-modal-wrap",
      ],
      easyListCzechSlovak: [
        "#onlajny-stickers",
        "#reklamni-box",
        ".reklama-megaboard",
        ".sklik",
        '[id^="sklikReklama"]',
      ],
      easyListDutch: [
        "#advertentie",
        "#vipAdmarktBannerBlock",
        ".adstekst",
        'a[href^="https://xlt' + 'ube.nl/click/"]',
        "#semilo-lrectangle",
      ],
      easyListGermany: [
        "#SSpotIMPopSlider",
        ".sponsorlinkgruen",
        "#werbungsky",
        "#reklame-rechts-mitte",
        'a[href^="https://bd' + '742.com/"]',
      ],
      easyListItaly: [
        ".box_adv_annunci",
        ".sb-box-pubbliredazionale",
        'a[href^="http://affili' + 'azioniads.snai.it/"]',
        'a[href^="https://adse' + 'rver.html.it/"]',
        'a[href^="https://affili' + 'azioniads.snai.it/"]',
      ],
      easyListLithuania: [
        ".reklamos_tarpas",
        ".reklamos_nuorodos",
        'img[alt="Reklaminis skydelis"]',
        'img[alt="Dedikuoti.lt serveriai"]',
        'img[alt="Hostingas Serveriai.lt"]',
      ],
      estonian: ['A[href*="http://pay4re' + 'sults24.eu"]'],
      fanboyAnnoyances: [
        "#ac-lre-player",
        ".navigate-to-top",
        "#subscribe_popup",
        ".newsletter_holder",
        "#back-top",
      ],
      fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
      fanboyEnhancedTrackers: [
        ".open.pushModal",
        "#issuem-leaky-paywall-articles-zero-remaining-nag",
        "#sovrn_container",
        'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
        ".BlockNag__Card",
      ],
      fanboySocial: [
        "#FollowUs",
        "#meteored_share",
        "#social_follow",
        ".article-sharer",
        ".community__social-desc",
      ],
      frellwitSwedish: [
        'a[href*="casin' + 'opro.se"][target="_blank"]',
        'a[href*="doktor-se.one' + 'link.me"]',
        "article.cat" + "egory-samarbete",
        "div.holidAds",
        "ul.adsmodern",
      ],
      greekAdBlock: [
        'A[href*="adman.ote' + 'net.gr/click?"]',
        'A[href*="http://axia' + "banners.exo" + 'dus.gr/"]',
        'A[href*="http://intera' + "ctive.fort" + 'hnet.gr/click?"]',
        "DIV.agores300",
        "TABLE.advright",
      ],
      hungarian: [
        "#cemp_doboz",
        ".optimonk-iframe-container",
        ".ad__main",
        '[class*="GoogleAds"]',
        "#hirdetesek_box",
      ],
      iDontCareAboutCookies: [
        '.alert-info[data-block-track*="CookieNotice"]',
        ".ModuleTemplateCookieIndicator",
        ".o--cookies--container",
        "#cookies-policy-sticky",
        "#stickyCookieBar",
      ],
      icelandicAbp: ['A[href^="/frame' + 'work/resources/forms/ads.aspx"]'],
      latvian: [
        'a[href="http://www.sali' +
          'dzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
        'a[href="http://www.salid' +
          'zini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]',
      ],
      listKr: [
        'a[href*="//ad.plan' + 'bplus.co.kr/"]',
        "#livereAdWrapper",
        'a[href*="//adv.ima' + 'drep.co.kr/"]',
        "ins.fastview-ad",
        ".reve" + "nue_unit_" + "item.da" + "ble",
      ],
      listeAr: [
        ".geminiLB1Ad",
        ".right-and-left-sponsers",
        'a[href*=".af' + 'lam.info"]',
        'a[href*="boo' + 'raq.org"]',
        'a[href*="dubi' + 'zzle.com/ar/?utm_source="]',
      ],
      listeFr: [
        'a[href^="http://pr' + "omo.vad" + 'or.com/"]',
        "#adcontainer_recherche",
        'a[href*="weborama.fr/fcgi-bin/"]',
        ".site-pub-interstitiel",
        'div[id^="crt-"][data-criteo-id]',
      ],
      officialPolish: [
        "#ceneo-placeholder-ceneo-12",
        '[href^="ht' + "tps://aff.sen" + 'dhub.pl/"]',
        'a[href^="http://advma' + "nager.tech" + 'fun.pl/redirect/"]',
        'a[href^="http://www.tri' + 'zer.pl/?utm_source"]',
        "div#skapiec_ad",
      ],
      ro: [
        'a[href^="//afftrk.al' + 'tex.ro/Counter/Click"]',
        'a[href^="ht' + "tps://black" + "frida" + 'ysales.ro/trk/shop/"]',
        'a[href^="ht' + "tps://event.2perfo" + 'rmant.com/events/click"]',
        'a[href^="https://l.profi' + 'tshare.ro/"]',
        'a[href^="/url/"]',
      ],
      ruAd: [
        'a[href*="//febr' + 'are.ru/"]',
        'a[href*="//uti' + 'mg.ru/"]',
        'a[href*="://chik' + 'idiki.ru"]',
        "#pgeldiz",
        ".yandex-rtb-block",
      ],
      thaiAds: [
        "a[href*=macau-uta-popup]",
        "#ads-google-middle_rectangle-group",
        ".ads300s",
        ".bumq",
        ".img-kosana",
      ],
      webAnnoyancesUltralist: [
        "#mod-social-share-2",
        "#social-tools",
        ".ctpl-fullbanner",
        ".zergnet-recommend",
        ".yt.btn-link.btn-md.btn",
      ],
    };
  }
  async function getDomBlockers({ debug } = {}) {
    if (!isApplicable()) {
      return undefined;
    }
    const filters = getFilters();
    const filterNames = Object.keys(filters);
    const allSelectors = [].concat(
      ...filterNames.map((filterName) => filters[filterName])
    );
    const blockedSelectors = await getBlockedSelectors(allSelectors);
    if (debug) {
      printDebug(filters, blockedSelectors);
    }
    const activeBlockers = filterNames.filter((filterName) => {
      const selectors = filters[filterName];
      const blockedCount = countTruthy(
        selectors.map((selector) => blockedSelectors[selector])
      );
      return blockedCount > selectors.length * 0.6;
    });
    activeBlockers.sort();
    return activeBlockers;
  }
  function isApplicable() {
    return isWebKit() || isAndroid();
  }
  async function getBlockedSelectors(selectors) {
    var _a;
    const d = document;
    const root = d.createElement("div");
    const elements = new Array(selectors.length);
    const blockedSelectors = {};
    forceShow(root);
    for (let i = 0; i < selectors.length; ++i) {
      const element = selectorToElement(selectors[i]);
      if (element.tagName === "DIALOG") {
        element.show();
      }
      const holder = d.createElement("div");
      forceShow(holder);
      holder.appendChild(element);
      root.appendChild(holder);
      elements[i] = element;
    }
    while (!d.body) {
      await wait(50);
    }
    d.body.appendChild(root);
    try {
      for (let i = 0; i < selectors.length; ++i) {
        if (!elements[i].offsetParent) {
          blockedSelectors[selectors[i]] = true;
        }
      }
    } finally {
      (_a = root.parentNode) === null || _a === void 0
        ? void 0
        : _a.removeChild(root);
    }
    return blockedSelectors;
  }
  function forceShow(element) {
    element.style.setProperty("visibility", "hidden", "important");
    element.style.setProperty("display", "block", "important");
  }
  function printDebug(filters, blockedSelectors) {
    let message = "DOM blockers debug:\n```";
    for (const filterName of Object.keys(filters)) {
      message += `\n${filterName}:`;
      for (const selector of filters[filterName]) {
        message += `\n  ${
          blockedSelectors[selector] ? "🚫" : "➡️"
        } ${selector}`;
      }
    }
    console.log(`${message}\n\`\`\``);
  }
  function getColorGamut() {
    for (const gamut of ["rec2020", "p3", "srgb"]) {
      if (matchMedia(`(color-gamut: ${gamut})`).matches) {
        return gamut;
      }
    }
    return undefined;
  }
  function areColorsInverted() {
    if (doesMatch$5("inverted")) {
      return true;
    }
    if (doesMatch$5("none")) {
      return false;
    }
    return undefined;
  }
  function doesMatch$5(value) {
    return matchMedia(`(inverted-colors: ${value})`).matches;
  }
  function areColorsForced() {
    if (doesMatch$4("active")) {
      return true;
    }
    if (doesMatch$4("none")) {
      return false;
    }
    return undefined;
  }
  function doesMatch$4(value) {
    return matchMedia(`(forced-colors: ${value})`).matches;
  }
  const maxValueToCheck = 100;
  function getMonochromeDepth() {
    if (!matchMedia("(min-monochrome: 0)").matches) {
      return undefined;
    }
    for (let i = 0; i <= maxValueToCheck; ++i) {
      if (matchMedia(`(max-monochrome: ${i})`).matches) {
        return i;
      }
    }
    throw new Error("Too high value");
  }
  function getContrastPreference() {
    if (doesMatch$3("no-preference")) {
      return 0;
    }
    if (doesMatch$3("high") || doesMatch$3("more")) {
      return 1;
    }
    if (doesMatch$3("low") || doesMatch$3("less")) {
      return -1;
    }
    if (doesMatch$3("forced")) {
      return 10;
    }
    return undefined;
  }
  function doesMatch$3(value) {
    return matchMedia(`(prefers-contrast: ${value})`).matches;
  }
  function isMotionReduced() {
    if (doesMatch$2("reduce")) {
      return true;
    }
    if (doesMatch$2("no-preference")) {
      return false;
    }
    return undefined;
  }
  function doesMatch$2(value) {
    return matchMedia(`(prefers-reduced-motion: ${value})`).matches;
  }
  function isTransparencyReduced() {
    if (doesMatch$1("reduce")) {
      return true;
    }
    if (doesMatch$1("no-preference")) {
      return false;
    }
    return undefined;
  }
  function doesMatch$1(value) {
    return matchMedia(`(prefers-reduced-transparency: ${value})`).matches;
  }
  function isHDR() {
    if (doesMatch("high")) {
      return true;
    }
    if (doesMatch("standard")) {
      return false;
    }
    return undefined;
  }
  function doesMatch(value) {
    return matchMedia(`(dynamic-range: ${value})`).matches;
  }
  const M = Math;
  const fallbackFn = () => 0;
  function getMathFingerprint() {
    const acos = M.acos || fallbackFn;
    const acosh = M.acosh || fallbackFn;
    const asin = M.asin || fallbackFn;
    const asinh = M.asinh || fallbackFn;
    const atanh = M.atanh || fallbackFn;
    const atan = M.atan || fallbackFn;
    const sin = M.sin || fallbackFn;
    const sinh = M.sinh || fallbackFn;
    const cos = M.cos || fallbackFn;
    const cosh = M.cosh || fallbackFn;
    const tan = M.tan || fallbackFn;
    const tanh = M.tanh || fallbackFn;
    const exp = M.exp || fallbackFn;
    const expm1 = M.expm1 || fallbackFn;
    const log1p = M.log1p || fallbackFn;
    const powPI = (value) => M.pow(M.PI, value);
    const acoshPf = (value) => M.log(value + M.sqrt(value * value - 1));
    const asinhPf = (value) => M.log(value + M.sqrt(value * value + 1));
    const atanhPf = (value) => M.log((1 + value) / (1 - value)) / 2;
    const sinhPf = (value) => M.exp(value) - 1 / M.exp(value) / 2;
    const coshPf = (value) => (M.exp(value) + 1 / M.exp(value)) / 2;
    const expm1Pf = (value) => M.exp(value) - 1;
    const tanhPf = (value) => (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1);
    const log1pPf = (value) => M.log(1 + value);
    return {
      acos: acos(0.123124234234234242),
      acosh: acosh(1e308),
      acoshPf: acoshPf(1e154),
      asin: asin(0.123124234234234242),
      asinh: asinh(1),
      asinhPf: asinhPf(1),
      atanh: atanh(0.5),
      atanhPf: atanhPf(0.5),
      atan: atan(0.5),
      sin: sin(-1e300),
      sinh: sinh(1),
      sinhPf: sinhPf(1),
      cos: cos(10.000000000123),
      cosh: cosh(1),
      coshPf: coshPf(1),
      tan: tan(-1e300),
      tanh: tanh(1),
      tanhPf: tanhPf(1),
      exp: exp(1),
      expm1: expm1(1),
      expm1Pf: expm1Pf(1),
      log1p: log1p(10),
      log1pPf: log1pPf(10),
      powPI: powPI(-100),
    };
  }
  const defaultText = "mmMwWLliI0fiflO&1";
  const presets = {
    default: [],
    apple: [
      {
        font: "-apple-system-body",
      },
    ],
    serif: [
      {
        fontFamily: "serif",
      },
    ],
    sans: [
      {
        fontFamily: "sans-serif",
      },
    ],
    mono: [
      {
        fontFamily: "monospace",
      },
    ],
    min: [
      {
        fontSize: "1px",
      },
    ],
    system: [
      {
        fontFamily: "system-ui",
      },
    ],
  };
  function getFontPreferences() {
    return withNaturalFonts((document, container) => {
      const elements = {};
      const sizes = {};
      for (const key of Object.keys(presets)) {
        const [style = {}, text = defaultText] = presets[key];
        const element = document.createElement("span");
        element.textContent = text;
        element.style.whiteSpace = "nowrap";
        for (const name of Object.keys(style)) {
          const value = style[name];
          if (value !== undefined) {
            element.style[name] = value;
          }
        }
        elements[key] = element;
        container.append(document.createElement("br"), element);
      }
      for (const key of Object.keys(presets)) {
        sizes[key] = elements[key].getBoundingClientRect().width;
      }
      return sizes;
    });
  }
  function withNaturalFonts(action, containerWidthPx = 4000) {
    return withIframe((_, iframeWindow) => {
      const iframeDocument = iframeWindow.document;
      const iframeBody = iframeDocument.body;
      const bodyStyle = iframeBody.style;
      bodyStyle.width = `${containerWidthPx}px`;
      bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = "none";
      if (isChromium()) {
        iframeBody.style.zoom = `${1 / iframeWindow.devicePixelRatio}`;
      } else if (isWebKit()) {
        iframeBody.style.zoom = "reset";
      }
      const linesOfText = iframeDocument.createElement("div");
      linesOfText.textContent = [...Array((containerWidthPx / 20) << 0)]
        .map(() => "word")
        .join(" ");
      iframeBody.appendChild(linesOfText);
      return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
  }
  function isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
  }
  function getArchitecture() {
    const f = new Float32Array(1);
    const u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
  }
  function getApplePayState() {
    const { ApplePaySession } = window;
    if (
      typeof (ApplePaySession === null || ApplePaySession === void 0
        ? void 0
        : ApplePaySession.canMakePayments) !== "function"
    ) {
      return -1;
    }
    if (willPrintConsoleError()) {
      return -3;
    }
    try {
      return ApplePaySession.canMakePayments() ? 1 : 0;
    } catch (error) {
      return getStateFromError(error);
    }
  }
  const willPrintConsoleError = isAnyParentCrossOrigin;
  function getStateFromError(error) {
    if (
      error instanceof Error &&
      error.name === "InvalidAccessError" &&
      /\bfrom\b.*\binsecure\b/i.test(error.message)
    ) {
      return -2;
    }
    throw error;
  }
  function getPrivateClickMeasurement() {
    var _a;
    const link = document.createElement("a");
    const sourceId =
      (_a = link.attributionSourceId) !== null && _a !== void 0
        ? _a
        : link.attributionsourceid;
    return sourceId === undefined ? undefined : String(sourceId);
  }
  const STATUS_NO_GL_CONTEXT = -1;
  const STATUS_GET_PARAMETER_NOT_A_FUNCTION = -2;
  const validContextParameters = new Set([
    10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961,
    2962, 2963, 2964, 2965, 2966, 2967, 2968, 2978, 3024, 3042, 3088, 3089,
    3106, 3107, 32773, 32777, 32777, 32823, 32824, 32936, 32937, 32938, 32939,
    32968, 32969, 32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902,
    34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414, 3415, 34467, 34816,
    34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739,
    36003, 36004, 36005, 36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937,
    7938,
  ]);
  const validExtensionParams = new Set([
    34047, 35723, 36063, 34852, 34853, 34854, 34229, 36392, 36795, 38449,
  ]);
  const shaderTypes = ["FRAGMENT_SHADER", "VERTEX_SHADER"];
  const precisionTypes = [
    "LOW_FLOAT",
    "MEDIUM_FLOAT",
    "HIGH_FLOAT",
    "LOW_INT",
    "MEDIUM_INT",
    "HIGH_INT",
  ];
  const rendererInfoExtensionName = "WEBGL_debug_renderer_info";
  const polygonModeExtensionName = "WEBGL_polygon_mode";
  function getWebGlBasics({ cache }) {
    var _a, _b, _c, _d, _e, _f;
    const gl = getWebGLContext(cache);
    if (!gl) {
      return STATUS_NO_GL_CONTEXT;
    }
    if (!isValidParameterGetter(gl)) {
      return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    }
    const debugExtension = shouldAvoidDebugRendererInfo()
      ? null
      : gl.getExtension(rendererInfoExtensionName);
    return {
      version:
        ((_a = gl.getParameter(gl.VERSION)) === null || _a === void 0
          ? void 0
          : _a.toString()) || "",
      vendor:
        ((_b = gl.getParameter(gl.VENDOR)) === null || _b === void 0
          ? void 0
          : _b.toString()) || "",
      vendorUnmasked: debugExtension
        ? (_c = gl.getParameter(debugExtension.UNMASKED_VENDOR_WEBGL)) ===
            null || _c === void 0
          ? void 0
          : _c.toString()
        : "",
      renderer:
        ((_d = gl.getParameter(gl.RENDERER)) === null || _d === void 0
          ? void 0
          : _d.toString()) || "",
      rendererUnmasked: debugExtension
        ? (_e = gl.getParameter(debugExtension.UNMASKED_RENDERER_WEBGL)) ===
            null || _e === void 0
          ? void 0
          : _e.toString()
        : "",
      shadingLanguageVersion:
        ((_f = gl.getParameter(gl.SHADING_LANGUAGE_VERSION)) === null ||
        _f === void 0
          ? void 0
          : _f.toString()) || "",
    };
  }
  function getWebGlExtensions({ cache }) {
    const gl = getWebGLContext(cache);
    if (!gl) {
      return STATUS_NO_GL_CONTEXT;
    }
    if (!isValidParameterGetter(gl)) {
      return STATUS_GET_PARAMETER_NOT_A_FUNCTION;
    }
    const extensions = gl.getSupportedExtensions();
    const contextAttributes = gl.getContextAttributes();
    const unsupportedExtensions = [];
    const attributes = [];
    const parameters = [];
    const extensionParameters = [];
    const shaderPrecisions = [];
    if (contextAttributes) {
      for (const attributeName of Object.keys(contextAttributes)) {
        attributes.push(`${attributeName}=${contextAttributes[attributeName]}`);
      }
    }
    const constants = getConstantsFromPrototype(gl);
    for (const constant of constants) {
      const code = gl[constant];
      parameters.push(
        `${constant}=${code}${
          validContextParameters.has(code) ? `=${gl.getParameter(code)}` : ""
        }`
      );
    }
    if (extensions) {
      for (const name of extensions) {
        if (
          (name === rendererInfoExtensionName &&
            shouldAvoidDebugRendererInfo()) ||
          (name === polygonModeExtensionName &&
            shouldAvoidPolygonModeExtensions())
        ) {
          continue;
        }
        const extension = gl.getExtension(name);
        if (!extension) {
          unsupportedExtensions.push(name);
          continue;
        }
        for (const constant of getConstantsFromPrototype(extension)) {
          const code = extension[constant];
          extensionParameters.push(
            `${constant}=${code}${
              validExtensionParams.has(code) ? `=${gl.getParameter(code)}` : ""
            }`
          );
        }
      }
    }
    for (const shaderType of shaderTypes) {
      for (const precisionType of precisionTypes) {
        const shaderPrecision = getShaderPrecision(
          gl,
          shaderType,
          precisionType
        );
        shaderPrecisions.push(
          `${shaderType}.${precisionType}=${shaderPrecision.join(",")}`
        );
      }
    }
    extensionParameters.sort();
    parameters.sort();
    return {
      contextAttributes: attributes,
      parameters: parameters,
      shaderPrecisions: shaderPrecisions,
      extensions: extensions,
      extensionParameters: extensionParameters,
      unsupportedExtensions,
    };
  }
  function getWebGLContext(cache) {
    if (cache.webgl) {
      return cache.webgl.context;
    }
    const canvas = document.createElement("canvas");
    let context;
    canvas.addEventListener(
      "webglCreateContextError",
      () => (context = undefined)
    );
    for (const type of ["webgl", "experimental-webgl"]) {
      try {
        context = canvas.getContext(type);
      } catch (_a) {}
      if (context) {
        break;
      }
    }
    cache.webgl = {
      context,
    };
    return context;
  }
  function getShaderPrecision(gl, shaderType, precisionType) {
    const shaderPrecision = gl.getShaderPrecisionFormat(
      gl[shaderType],
      gl[precisionType]
    );
    return shaderPrecision
      ? [
          shaderPrecision.rangeMin,
          shaderPrecision.rangeMax,
          shaderPrecision.precision,
        ]
      : [];
  }
  function getConstantsFromPrototype(obj) {
    const keys = Object.keys(obj.__proto__);
    return keys.filter(isConstantLike);
  }
  function isConstantLike(key) {
    return typeof key === "string" && !key.match(/[^A-Z0-9_x]/);
  }
  function shouldAvoidDebugRendererInfo() {
    return isGecko();
  }
  function shouldAvoidPolygonModeExtensions() {
    return isChromium() || isWebKit();
  }
  function isValidParameterGetter(gl) {
    return typeof gl.getParameter === "function";
  }
  function getAudioContextBaseLatency() {
    const isAllowedPlatform = isAndroid() || isWebKit();
    if (!isAllowedPlatform) {
      return -2;
    }
    if (!window.AudioContext) {
      return -1;
    }
    const latency = new AudioContext().baseLatency;
    if (latency === null || latency === undefined) {
      return -1;
    }
    if (!isFinite(latency)) {
      return -3;
    }
    return latency;
  }
  function getDateTimeLocale() {
    if (!window.Intl) {
      return -1;
    }
    const DateTimeFormat = window.Intl.DateTimeFormat;
    if (!DateTimeFormat) {
      return -2;
    }
    const locale = DateTimeFormat().resolvedOptions().locale;
    if (!locale && locale !== "") {
      return -3;
    }
    return locale;
  }
  const sources = {
    fonts: getFonts,
    domBlockers: getDomBlockers,
    fontPreferences: getFontPreferences,
    audio: getAudioFingerprint,
    screenFrame: getScreenFrame,
    canvas: getCanvasFingerprint,
    osCpu: getOsCpu,
    languages: getLanguages,
    colorDepth: getColorDepth,
    deviceMemory: getDeviceMemory,
    screenResolution: getScreenResolution,
    hardwareConcurrency: getHardwareConcurrency,
    timezone: getTimezone,
    sessionStorage: getSessionStorage,
    localStorage: getLocalStorage,
    indexedDB: getIndexedDB,
    openDatabase: getOpenDatabase,
    cpuClass: getCpuClass,
    platform: getPlatform,
    plugins: getPlugins,
    touchSupport: getTouchSupport,
    vendor: getVendor,
    vendorFlavors: getVendorFlavors,
    cookiesEnabled: areCookiesEnabled,
    colorGamut: getColorGamut,
    invertedColors: areColorsInverted,
    forcedColors: areColorsForced,
    monochrome: getMonochromeDepth,
    contrast: getContrastPreference,
    reducedMotion: isMotionReduced,
    reducedTransparency: isTransparencyReduced,
    hdr: isHDR,
    math: getMathFingerprint,
    pdfViewerEnabled: isPdfViewerEnabled,
    architecture: getArchitecture,
    applePay: getApplePayState,
    privateClickMeasurement: getPrivateClickMeasurement,
    audioBaseLatency: getAudioContextBaseLatency,
    dateTimeLocale: getDateTimeLocale,
    webGlBasics: getWebGlBasics,
    webGlExtensions: getWebGlExtensions,
  };
  function loadBuiltinSources(options) {
    return loadSources(sources, options, []);
  }
  const commentTemplate = "$ if upgrade to Pro: https://fpjs.dev/pro";
  function getConfidence(components) {
    const openConfidenceScore = getOpenConfidenceScore(components);
    const proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
    return {
      score: openConfidenceScore,
      comment: commentTemplate.replace(/\$/g, `${proConfidenceScore}`),
    };
  }
  function getOpenConfidenceScore(components) {
    if (isAndroid()) {
      return 0.4;
    }
    if (isWebKit()) {
      return isDesktopWebKit() && !(isWebKit616OrNewer() && isSafariWebKit())
        ? 0.5
        : 0.3;
    }
    const platform =
      "value" in components.platform ? components.platform.value : "";
    if (/^Win/.test(platform)) {
      return 0.6;
    }
    if (/^Mac/.test(platform)) {
      return 0.5;
    }
    return 0.7;
  }
  function deriveProConfidenceScore(openConfidenceScore) {
    return round(0.99 + 0.01 * openConfidenceScore, 0.0001);
  }
  function componentsToCanonicalString(components) {
    let result = "";
    for (const componentKey of Object.keys(components).sort()) {
      const component = components[componentKey];
      const value =
        "error" in component ? "error" : JSON.stringify(component.value);
      result += `${result ? "|" : ""}${componentKey.replace(
        /([:|\\])/g,
        "\\$1"
      )}:${value}`;
    }
    return result;
  }
  function componentsToDebugString(components) {
    return JSON.stringify(
      components,
      (_key, value) => {
        if (value instanceof Error) {
          return errorToObject(value);
        }
        return value;
      },
      2
    );
  }
  function hashComponents(components) {
    return x64hash128(componentsToCanonicalString(components));
  }
  function makeLazyGetResult(components) {
    let visitorIdCache;
    const confidence = getConfidence(components);
    return {
      get visitorId() {
        if (visitorIdCache === undefined) {
          visitorIdCache = hashComponents(this.components);
        }
        return visitorIdCache;
      },
      set visitorId(visitorId) {
        visitorIdCache = visitorId;
      },
      confidence,
      components,
      version,
    };
  }
  function prepareForSources(delayFallback = 50) {
    return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
  }
  function makeAgent(getComponents, debug) {
    const creationTime = Date.now();
    return {
      async get(options) {
        const startTime = Date.now();
        const components = await getComponents();
        const result = makeLazyGetResult(components);
        if (
          debug ||
          (options === null || options === void 0 ? void 0 : options.debug)
        ) {
          console.log(`Copy the text below to get the debug data:

\`\`\`
version: ${result.version}
userAgent: ${navigator.userAgent}
timeBetweenLoadAndGet: ${startTime - creationTime}
visitorId: ${result.visitorId}
components: ${componentsToDebugString(components)}
\`\`\``);
        }
        return result;
      },
    };
  }
  function monitor() {
    if (window.__fpjs_d_m || Math.random() >= 0.001) {
      return;
    }
    try {
      const request = new XMLHttpRequest();
      request.open(
        "get",
        `https://m1.openfpcdn.io/fingerprintjs/v${version}/npm-monitoring`,
        true
      );
      request.send();
    } catch (error) {
      console.error(error);
    }
  }
  async function load(options = {}) {
    const { delayFallback, debug, monitoring = true } = options;
    if (monitoring) {
      monitor();
    }
    await prepareForSources(delayFallback);
    const getComponents = loadBuiltinSources({
      cache: {},
      debug,
    });
    return makeAgent(getComponents, debug);
  }

  function initFingerprint1() {
    return _initFingerprint.apply(this, arguments);
  }
  function _initFingerprint() {
    _initFingerprint = _asyncToGenerator(
      _regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1)
            switch (_context2.n) {
              case 0:
                return _context2.a(
                  2,
                  load({
                    monitoring: false,
                  })
                    .then(function (fp) {
                      return fp.get();
                    })
                    .then(function (result) {
                      var visitorId = result.visitorId;
                      return visitorId;
                    })
                );
            }
        }, _callee2);
      })
    );
    return _initFingerprint.apply(this, arguments);
  }
  var EXCLUDE_LIST = [
    "fontPreferences",
    "screenFrame",
    "screenResolution",
    "touchSupport",
  ];
  function initFingerprint2() {
    return _initFingerprint2.apply(this, arguments);
  }
  function _initFingerprint2() {
    _initFingerprint2 = _asyncToGenerator(
      _regenerator().m(function _callee3() {
        var debug, getComponents, components, visitorId;
        return _regenerator().w(function (_context3) {
          while (1)
            switch (_context3.n) {
              case 0:
                debug = false;
                _context3.n = 1;
                return prepareForSources();
              case 1:
                getComponents = loadSources(
                  sources,
                  {
                    cache: {},
                    debug: debug,
                  },
                  EXCLUDE_LIST
                );
                _context3.n = 2;
                return getComponents();
              case 2:
                components = _context3.v;
                visitorId = hashComponents(components);
                return _context3.a(2, visitorId);
            }
        }, _callee3);
      })
    );
    return _initFingerprint2.apply(this, arguments);
  }
  var Tracker = (window._WL_CLASS_TRACKER =
    window._WL_CLASS_TRACKER ||
    (function () {
      function _class(_ref) {
        var trackDatas = _ref.trackDatas,
          rootUrl = _ref.rootUrl,
          _ref$trackUrl = _ref.trackUrl,
          trackUrl = _ref$trackUrl === void 0 ? "" : _ref$trackUrl,
          _ref$query = _ref.query,
          query = _ref$query === void 0 ? {} : _ref$query,
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers,
          _ref$clickTrack = _ref.clickTrack,
          clickTrack = _ref$clickTrack === void 0 ? false : _ref$clickTrack,
          _ref$globalTrackName = _ref.globalTrackName,
          globalTrackName =
            _ref$globalTrackName === void 0 ? "wstrack" : _ref$globalTrackName,
          _ref$onRedirect = _ref.onRedirect,
          onRedirect =
            _ref$onRedirect === void 0 ? function () {} : _ref$onRedirect;
        if ((this instanceof _class ? this.constructor : void 0) !== Tracker) {
          return;
        }
        if (!Tracker._instance) {
          this.trackDatas = trackDatas;
          this.rootUrl = rootUrl;
          this.trackUrl = trackUrl || rootUrl + "/marketing_track/track";
          this.headers = headers;
          this.query = query;
          this.onRedirect = onRedirect;
          this.stayTime = 0;
          this.maxStayTime = 300;
          this.timer = "";
          this.interval = 5;
          this.currentPath = location.href;
          this.event_id = "";
          this.clickTrack = clickTrack;
          this.clickEleAttr = "data-ws-track";
          this.initEvent();
          this.startTrack();
          Tracker._instance = this;
          if (globalTrackName) {
            window[globalTrackName] = function (name) {
              var data = {};
              if (typeof name === "object") {
                data = name;
              } else if (typeof name == "function") {
                var res = name();
                if (typeof res === "object") {
                  data = res;
                } else {
                  data.name = res;
                }
              } else {
                data.name = name;
              }
              return Tracker._instance.track(
                _extends({}, data, {
                  type: 1,
                }),
                true
              );
            };
          }
        }
        return Tracker._instance;
      }
      var _proto = _class.prototype;
      _proto.initEvent = function initEvent() {
        var t = this;
        if (t.clickTrack) {
          var isProcessing = false;
          document.addEventListener("click", function (event) {
            if (isProcessing) {
              return;
            }
            var target = event.target.closest(
              "[" + t.clickEleAttr + "]:not([disabled]):not(.disabled)"
            );
            if (target) {
              isProcessing = true;
              var trackValue = target.getAttribute(t.clickEleAttr);
              if (trackValue) {
                t.track(
                  {
                    type: 1,
                    name: trackValue,
                  },
                  true
                );
              }
              setTimeout(function () {
                isProcessing = false;
              }, 100);
            }
          }, true);
        }
        window.addEventListener("popstate", function () {
          setTimeout(function () {
            t.startTrack();
            if (t.currentPath != location.href) {
              t.currentPath = location.href;
              t.onRedirect();
            }
          });
        });
        (function (history) {
          var pushState = history.pushState;
          var replaceState = history.replaceState;
          var currentUrl = location.href;
          history.pushState = function () {
            setTimeout(function () {
              if (currentUrl !== location.href) {
                currentUrl = location.href;
                t.startTrack();
                t.onRedirect();
              }
            });
            return pushState.apply(history, arguments);
          };
          history.replaceState = function () {
            setTimeout(function () {
              if (currentUrl !== location.href) {
                currentUrl = location.href;
                t.startTrack();
                t.onRedirect();
              }
            }, 0);
            return replaceState.apply(history, arguments);
          };
        })(window.history);
      };
      _proto.startTrack = function startTrack() {
        var flag = "占位,防止两套track";
        if (!window.weilingFlag || window.weilingFlag == flag) {
          window.weilingFlag = flag;
          this.stayTime = 0;
          clearInterval(this.timer);
          this.startWatchStayTime();
        }
      };
      _proto.startWatchStayTime = function startWatchStayTime() {
        var t = this;
        t.track();
        this.timer = setInterval(function () {
          t.stayTime += t.interval;
          if (t.stayTime > t.maxStayTime) {
            clearInterval(t.timer);
          } else {
            t.track();
          }
        }, t.interval * 1000);
      };
      _proto.track = (function () {
        var _track = _asyncToGenerator(
          _regenerator().m(function _callee(trackDatas, isolated) {
            var _trackDatas$type;
            var t, type, sendData, queryStr;
            return _regenerator().w(
              function (_context) {
                while (1)
                  switch (_context.n) {
                    case 0:
                      if (trackDatas === void 0) {
                        trackDatas = {};
                      }
                      if (isolated === void 0) {
                        isolated = false;
                      }
                      t = this;
                      type =
                        (_trackDatas$type = trackDatas.type) != null
                          ? _trackDatas$type
                          : t.stayTime === 0 || !t.event_id
                          ? 1
                          : 2;
                      if (t.fullFingerprint) {
                        _context.n = 3;
                        break;
                      }
                      _context.n = 1;
                      return initFingerprint1();
                    case 1:
                      t.fullFingerprint = _context.v;
                      _context.n = 2;
                      return initFingerprint2();
                    case 2:
                      t.simpleFingerprint = _context.v;
                    case 3:
                      sendData = _extends(
                        {
                          referer: document.referrer,
                          title: document.title,
                          type: type,
                          url: document.URL,
                          full_fingerprint: t.fullFingerprint,
                          simple_fingerprint: t.simpleFingerprint,
                        },
                        t.trackDatas,
                        trackDatas
                      );
                      if (type === 2) {
                        sendData.duration = t.stayTime;
                        sendData.event_id = t.event_id;
                      }
                      if (!t.query) {
                        t.query = {};
                      }
                      t.query.ttype = type;
                      queryStr = new URLSearchParams(t.query).toString();
                      return _context.a(
                        2,
                        post(t.trackUrl + "?" + queryStr, sendData, {
                          timeout: 4900,
                          withCredentials: true,
                          headers: t.headers,
                        })
                          .then(function (res) {
                            if (res.code == 200) {
                              if (!isolated) {
                                t.event_id = res.event_id || res.data.event_id;
                              }
                            } else {
                              console.log(res);
                            }
                            return res;
                          })
                          ["catch"](function (err) {
                            console.log(err);
                            return err;
                          })
                      );
                  }
              },
              _callee,
              this
            );
          })
        );
        function track(_x, _x2) {
          return _track.apply(this, arguments);
        }
        return track;
      })();
      return _class;
    })());

  function getQueryVariable(variable) {
    var url = window.location.href;
    if (url.indexOf("?") != -1) {
      var temp1 = url.split("?");
      var pram = temp1[1];
      var keyValue = pram.split("&");
      for (var i = 0; i < keyValue.length; i++) {
        var item = keyValue[i].split("=");
        if (item[0] == variable) {
          return item[1].split("#")[0];
        }
      }
    }
    return "";
  }

  function initTrack() {
    return new Tracker({
      trackUrl: LCTrack.trackUrl,
      trackDatas: {
        name: LCTrack.initParams.abbrev_name || "网页",
      },
      headers: LCTrack.initParams.headers,
      clickTrack: true,
      globalTrackName: LCTrack.initParams.globalTrackName || "wstrack",
    });
  }
  var LCTrack = {
    preInit: function preInit(initParams) {
      initParams.istest =
        initParams.istest === undefined
          ? getQueryVariable("istest") || false
          : initParams.istest;
      var trackDomain = "https://api.leadcontact.ai";
      if (initParams.istest) {
        trackDomain = "https://api.demo.leadcontact.ai";
      }
      this.trackUrl = trackDomain + "/api/website/track";
      this.initParams = initParams;
    },
    init: function init(initParams) {
      this.preInit(initParams || {});
      return initTrack();
    },
  };
  window.LCTrack = LCTrack;

  return LCTrack;
})();
